import 'antd/dist/reset.css';
import '@ant-design/compatible/lib/form/style';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/general.scss';
import './styles/override.scss';
// Import Ant Design global reset styles so component styles (e.g. Form, Buttons) are applied
import App from './App';
import { createLogger } from 'redux-logger';
import configureStore from './redux/configureStore';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import translations from '~/locales';
import { datadogRum } from '@datadog/browser-rum';

(async () => {
  try {
    const res = await fetch('/api/config/datadog');
    const {
      DD_SUI_UI_APP_ID,
      DD_SUI_UI_CLIENT_TOKEN,
      DD_ENV,
      DD_SITE,
      DD_SUI_UI_SERVICE_NAME,
      DD_SUI_UI_VERSION
    } = await res.json();

    if (
      DD_SUI_UI_APP_ID &&
      DD_SUI_UI_CLIENT_TOKEN &&
      process.env.NODE_ENV === 'production'
    ) {
      datadogRum.init({
        applicationId: DD_SUI_UI_APP_ID,
        clientToken: DD_SUI_UI_CLIENT_TOKEN,
        site: DD_SITE,
        service: DD_SUI_UI_SERVICE_NAME,
        env: DD_ENV,
        version: DD_SUI_UI_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackUserInteractions: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
      });
      datadogRum.startSessionReplayRecording();
    } else {
      console.log(
        'Datadog RUM not initialized due to missing config or non-production environment'
      );
    }
  } catch (err) {
    console.log('Failed to initialize Datadog RUM', err);
  }
})();

const loggerMiddleware = createLogger();
const store = configureStore({}, loggerMiddleware);

const locale = 'en-US';

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale={locale} messages={translations[locale]}>
      <App />
    </IntlProvider>
  </Provider>,
  // createElement for test env
  document.getElementById('root') || document.createElement('div')
);
